module.exports = __webpack_public_path__ + "static/media/r_itdot_6.f32dbbdc.png";